import { render, staticRenderFns } from "./nu_padm.vue?vue&type=template&id=6398ef20&"
import script from "./nu_padm.vue?vue&type=script&lang=js&"
export * from "./nu_padm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports